import { useEffect, useRef } from 'react';
import { supabase } from '../../shared/supabase/supabaseClient';
import type { ConsultationMessage, ConsultationRow } from '../infra/consultationsRepo';

export function useConsultationRealtime(
  consultationId: string,
  onNewMessage: (msg: ConsultationMessage) => void,
  onConsultationUpdate?: (consultation: Partial<ConsultationRow>) => void,
) {
  const msgCbRef = useRef(onNewMessage);
  const updateCbRef = useRef(onConsultationUpdate);
  useEffect(() => {
    msgCbRef.current = onNewMessage;
    updateCbRef.current = onConsultationUpdate;
  }, [onNewMessage, onConsultationUpdate]);

  useEffect(() => {
    if (!consultationId) return;

    const channel = supabase
      .channel(`consultation-${consultationId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'store_consultation_messages',
          filter: `consultation_id=eq.${consultationId}`,
        },
        (payload: { new: ConsultationMessage }) => {
          msgCbRef.current(payload.new);
        },
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'store_consultations',
          filter: `id=eq.${consultationId}`,
        },
        (payload: { new: Partial<ConsultationRow> }) => {
          updateCbRef.current?.(payload.new);
        },
      )
      .subscribe();

    return () => {
      void supabase.removeChannel(channel);
    };
  }, [consultationId]);
}
